import { Component, EventEmitter, inject, Output } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { SortOrder } from '@cure-common/enum';
import { SelectOptionType } from '@cure-common/interfaces';

@Component({
  selector: 'app-sort-select',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, MatInputModule, ReactiveFormsModule],
  templateUrl: './sort-select.component.html',
  styleUrl: './sort-select.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SortSelectComponent,
    },
  ],
})
export class SortSelectComponent implements ControlValueAccessor {
  @Output() onSelect = new EventEmitter<SortOrder | null>();

  public readonly OPTIONS: SelectOptionType<string>[] = [
    {
      label: 'All',
      value: '',
    },
    {
      label: 'Oldest first',
      value: SortOrder.OLDEST_FIRST,
    },
    {
      label: 'Newest first',
      value: SortOrder.NEWEST_FIRST,
    },
    {
      label: 'A → Z',
      value: SortOrder.ASCENDING,
    },
    {
      label: 'Z → A',
      value: SortOrder.DESCENDING,
    },
  ];

  public handleSelect(event: SortOrder | null): void {
    if (this.disabled) return;

    this.onSelect.emit(event);
    this.value = event;
    this.onChange(event);
    this.markAsTouched();
  }

  value: SortOrder | null = null;
  touched = false;
  disabled = false;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (value: SortOrder | null) => {};
  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  writeValue(value: SortOrder | null): void {
    this.value = value;
  }

  private markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
